import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { Injectable, ComponentRef } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { CanDeactivate, ActivatedRouteSnapshot } from '@angular/router';

import { AccountManagementService } from '../services/account-management.service';

@Injectable()
export class BusinessInfoCancellationGuard implements CanDeactivate<ComponentRef<any>> {
  constructor(
    private viewportScroller: ViewportScroller,
    private accountManagementService: AccountManagementService,
  ) {}

  public canDeactivate(component: ComponentRef<any>, currentRoute: ActivatedRouteSnapshot): Observable<boolean> {
    return this.accountManagementService.canLeaveFromAddBusinessInfoPage().pipe(
      tap((canDeactivate) => {
        if (!canDeactivate) {
          this.viewportScroller.scrollToPosition([0, 0]);
        }
      }),
    );
  }
}
